"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _Functions = require("../core/Functions");

var ActiveProvider =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(ActiveProvider, _React$Component);

  function ActiveProvider(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ActiveProvider);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ActiveProvider).call(this, props));

    _this.handleMouseDown = function (evt) {
      (0, _Functions.callIfPossible)(_this.props.onMouseDown, evt);

      _this.setState({
        active: true
      });

      _this._handleWindowMouseUp = function () {
        _this.setState({
          active: false
        });

        window.removeEventListener('mouseup', _this._handleWindowMouseUp);
      };

      window.addEventListener('mouseup', _this._handleWindowMouseUp);
    };

    _this.handleKeyDown = function (evt) {
      (0, _Functions.callIfPossible)(_this.props.onKeyDown, evt);
      var key = evt.key;
      if (key !== 'Enter' && key !== ' ') return;

      _this.setState({
        active: true
      });
    };

    _this.handleKeyUp = function (evt) {
      (0, _Functions.callIfPossible)(_this.props.onKeyUp, evt);
      var key = evt.key;
      if (key !== 'Enter' && key !== ' ') return;

      _this.setState({
        active: false
      });
    };

    _this.handleBlur = function (evt) {
      (0, _Functions.callIfPossible)(_this.props.onKeyUp, evt);
      if (_this.state.active) _this.setState({
        active: false
      });
    };

    _this.state = {
      active: false
    };
    return _this;
  }

  (0, _createClass2.default)(ActiveProvider, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('mouseup', this._handleWindowMouseUp);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          activeProp = _this$props.active;
      var active = this.state.active;
      return children({
        active: activeProp != null ? activeProp : active,
        onMouseDown: this.handleMouseDown,
        onKeyDown: this.handleKeyDown,
        onKeyUp: this.handleKeyUp,
        onBlur: this.handleBlur
      });
    }
  }]);
  return ActiveProvider;
}(_react.default.Component);

ActiveProvider.displayName = 'ActiveProvider';
var _default = ActiveProvider;
exports.default = _default;
module.exports = exports.default;